import { Component, OnInit } from '@angular/core';
import { LanguageService } from './services/language.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  templateUrl: './app-footer.html',
  styleUrls: ['./app-footer.scss']
})
export class AppFooter implements OnInit {
  whatsappUrl = '';

  constructor(private languageService: LanguageService) {}

  ngOnInit(): void {
    // Set appropriate WhatsApp URL based on device
    this.setWhatsAppUrl();
  }

  private setWhatsAppUrl(): void {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    if (isMobile) {
      // For mobile devices, use wa.me URL to open WhatsApp app
      this.whatsappUrl = 'https://wa.me/917378932424';
    } else {
      // For desktop, use WhatsApp Web
      this.whatsappUrl = 'https://web.whatsapp.com/send?phone=917378932424';
    }
  }

  t(key: string, params?: { [key: string]: string | number }): string {
    return this.languageService.t(key, params);
  }

  getCurrentYear(): number {
    return new Date().getFullYear();
  }
}
